import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import RateContent from './RateContent';
import RateModal from '../components/RateModal';

const form = {
  keyword: '',
};

function RateContainer({
  match,
  history,
  getRateList,
  rateList,
  isLoading,
  removeRate,
  rateListPager,
  getSingleRate,
  ordinanceRevisionId,
  clearItem,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <RateModal type="NEW" ordinanceRevisionId={ordinanceRevisionId} />
      ),
      title: 'Add Rate',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <RateModal
          type="EDIT"
          updateList={data.attributes}
          rateId={data.id}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Update Rate',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Rate?',
      () => {
        removeRate(data.id, () => {
          getRateList(
            { ordinance_revision_id: ordinanceRevisionId },
            (response) => {
              const id = _.get(response, 'res.data.0.id');
              history.push(`/rpt/land/land-settings/rates/${id}`);
              getSingleRate(id);
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getRateList({ ordinance_revision_id: ordinanceRevisionId }, (res) => {
      const id = _.get(res, 'data.0.id');
      if (id) {
        history.push(`/rpt/land/land-settings/rates/${id}`);
        getSingleRate(id);
      } else clearItem(c.GET_SINGLE_RATE, {});
    });
    return () => {
      setModal({ isOpen: false });
    };
  }, [ordinanceRevisionId]);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getRateList({
        q: formData.keyword,
        ordinance_revision_id: ordinanceRevisionId,
      });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:rateId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Rate"
            getData={getRateList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:rateId?`}
            listName="Rates"
            label="Rates"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.code')}</div>
            )}
            isLoading={isLoading}
            selected={params.rateId}
            data={rateList}
            dataPager={rateListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:rateId?`}
                    render={() => (
                      <RateContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:rateId?`}
                  render={() =>
                    !params.rateId && rateList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(rateList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

RateContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getRateList: PropTypes.instanceOf(Function).isRequired,
  rateList: PropTypes.instanceOf(Array).isRequired,
  rateListPager: PropTypes.instanceOf(Object).isRequired,
  removeRate: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  getSingleRate: PropTypes.instanceOf(Function).isRequired,
  clearItem: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  rateList: _.get(api, `${c.GET_RATE}.list`) || [],
  rateListPager: _.get(api, `${c.GET_RATE}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_RATE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RateContainer);
